/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelHistoryItemResource } from './';
import {
    ServiceLevelHistoryItemResourceFromJSON,
    ServiceLevelHistoryItemResourceFromJSONTyped,
    ServiceLevelHistoryItemResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceLevelHistoryResource
 */
export interface ServiceLevelHistoryResource {
    /**
     * 
     * @type {Array<ServiceLevelHistoryItemResource>}
     * @memberof ServiceLevelHistoryResource
     */
    history: Array<ServiceLevelHistoryItemResource>;
}

/**
 * Check if a given object implements the ServiceLevelHistoryResource interface.
 */
export function instanceOfServiceLevelHistoryResource(value: object): value is ServiceLevelHistoryResource {
    if (!('history' in value) || value['history'] === undefined) return false;
    return true;
}

export function ServiceLevelHistoryResourceFromJSON(json: any): ServiceLevelHistoryResource {
    return ServiceLevelHistoryResourceFromJSONTyped(json, false);
}

export function ServiceLevelHistoryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelHistoryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'history': ((json['history'] as Array<any>).map(ServiceLevelHistoryItemResourceFromJSON)),
    };
}

export function ServiceLevelHistoryResourceToJSON(value?: ServiceLevelHistoryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'history': ((value['history'] as Array<any>).map((v) => ServiceLevelHistoryItemResourceToJSON(v))),
    };
}

